import React, { Component } from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { Row, Container, Image, Table } from 'react-bootstrap'
import times from 'lodash/times'
import fromPairs from 'lodash/fromPairs'
import map from 'lodash/map'
import assign from 'lodash/assign'
import { catalogContainer } from 'src/models'
import { pageNames } from 'src/routes/pathParams'
import { tryJSONParse } from 'src/utils'
import { i18nTranslate } from 'src/utils'
import { MetaDecorator } from 'src/views/components'
import './styles.scss'

const compareAttributes = {
  category: 'comparableAttr',
  product: 'comparableAttr',
  specification: 'specification',
}

@observer
class ProductsCompare extends Component {
  @observable productsList = []
  category = {}

  componentDidMount() {
    this.getProducts()
  }

  assignDefaultCategory = (property, key) => {
    if (key === compareAttributes.specification) {
      const transformedData = fromPairs(
        map(property, i => {
          const label = `${key}.${i.label}`
          return [label, i.label]
        })
      )
      this.category = { ...this.category, ...transformedData }
    }
  }

  getProducts = async () => {
    const productIds = (
      this.props?.location?.queryParams?.productids || []
    )?.split(',')

    let promises = times(productIds.length, async index => {
      return await catalogContainer
        .getProduct({
          productId: productIds[index],
        })
        .then(response => {
          if (index === 0) {
            const category =
              response?.category?.properties?.[compareAttributes?.category] ||
              '{}'
            this.category = tryJSONParse(category, [])
          }
          return response
        })
    })

    Promise.all(promises).then(results => {
      this.productsList = results.map(result => {
        const properties = result?.product?.[0]?.properties || {}
        const editedProperties = {}
        editedProperties['identifier'] = result?.product?.[0]?.identifier || ''
        Object.keys(properties).forEach(propertyKey => {
          try {
            const prop = JSON.parse(properties[propertyKey])
            this.assignDefaultCategory(prop, propertyKey)
            editedProperties[propertyKey] = prop
            const parsedProps = fromPairs(
              map(editedProperties[propertyKey], i => {
                const label = `${propertyKey}.${i.label}`
                return [label, i.value]
              })
            )
            assign(editedProperties, parsedProps)
          } catch (e) {
            editedProperties[propertyKey] = properties[propertyKey]
          }
        })
        return editedProperties
      })
    })
  }

  renderDetails = (product, key) => {
    const value = product[key] || '-'
    return (
      <td
        key={`property_${product.identifier}`}
        className={`border-right ${
          value === '-' ? 'text-center no-value' : ''
        }`}>
        {value}
      </td>
    )
  }

  renderHeader = product => {
    const { name, imageURL, identifier } = product || {}
    return (
      <Link
        to={`${pageNames.product}/${identifier}`}
        key={identifier}
        className="product-wrapper d-flex flex-column border-right px-2 text-dark text-decoration-none">
        <Image fluid src={imageURL} className="mb-2" />
        <div className="text-center">{name}</div>
      </Link>
    )
  }

  renderPropertyDetails = (property, index) => {
    const [key, value] = property
    const emptyContainerLength =
      catalogContainer.productCompareLimit - this.productsList.length
    if (!value) {
      return ''
    }
    return (
      <tr key={key} className="border-bottom">
        <td className="border-right font-weight-bold" key={`property_${index}`}>
          {value}
        </td>
        {this.productsList.map(product => {
          return this.renderDetails(product, key)
        })}
        {times(emptyContainerLength, () => {
          return <td className="product-wrapper border-right" />
        })}
      </tr>
    )
  }

  render() {
    const emptyContainerLength =
      catalogContainer.productCompareLimit - this.productsList.length

    const productCompareTitle = i18nTranslate(
      'productComparePage.title',
      'Compare Products | Nu Skin',
      {
        nameSpace: 'ssr-resource',
      }
    )

    return (
      <>
        <MetaDecorator
          title={productCompareTitle}
          imageUrl=""
          imageAlt=""
          description="Compare Products page"
          location={this.props}
        />
        <Container className="p-0 product-compare-page">
          <h1 className="text-center mb-5">
            {i18nTranslate('compare.productCompare', 'Product Compare')}
          </h1>
          <Row noGutters className="border-bottom comparison-header mb-1">
            <div className="product-wrapper border-right" />
            {this.productsList.map(this.renderHeader)}
            {times(emptyContainerLength, () => {
              return <div className="product-wrapper border-right" />
            })}
          </Row>
          <Table className="properties-table">
            <tbody>
              {this.productsList.length > 0 &&
                Object.entries(this.category).length > 0 &&
                Object.entries(this.category).map(this.renderPropertyDetails)}
            </tbody>
          </Table>
        </Container>
      </>
    )
  }
}

export { ProductsCompare }

// export default ProductsCompare
export default ProductsCompare
